"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const provider_components_1 = require("@kyruus/provider-components");
const styles_1 = require("./styles");
/**
 * Renders the badges for a provider.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {import('@kyruus/types').PMCConfig} props.config - The configuration object.
 * @param {import('@kyruus/types').ProviderMatchProviderV9} props.provider - The provider object.
 * @param {Array} props.badgeFields - The array of badge fields.
 * @param {String} props.renderLocation - The render location string.
 * @param {import('@kyruus/intl').IntlShape} props.intl - The internationalization object.
 * @returns {JSX.Element} The rendered component.
 */
const ProviderProfileBadges = ({ config, provider, badgeFields, renderLocation, intl }) => {
    return (react_1.default.createElement(styles_1.BadgeWrapper, { "data-testid": "ProviderBadges" },
        react_1.default.createElement(provider_components_1.ProviderBadges, { provider: provider, badgeFields: badgeFields, renderLocation: renderLocation }),
        (0, provider_components_1.displayBookOnlineBadge)(config, provider) && (react_1.default.createElement(provider_components_1.ProviderBadge, { badge: {
                label: intl.formatMessage(provider_components_1.messages.onlinebooking)
            }, renderLocation: renderLocation })),
        (0, provider_components_1.displayVirtualProviderBadge)(config, provider) && (react_1.default.createElement(provider_components_1.ProviderBadge, { badge: {
                label: intl.formatMessage(provider_components_1.messages.appointmentVideoTitle)
            }, renderLocation: renderLocation })),
        (0, provider_components_1.displayPhoneVisitBadge)(config, provider) && (react_1.default.createElement(provider_components_1.ProviderBadge, { badge: {
                label: intl.formatMessage(provider_components_1.messages.appointmentPhoneTitle)
            }, renderLocation: renderLocation }))));
};
exports.default = (0, intl_1.injectIntl)(ProviderProfileBadges);
//# sourceMappingURL=provider-badges.js.map